import * as actions from '../actions/solicitorGroup';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import flattenConcurrently from 'xstream/extra/flattenConcurrently';
import flattenSequentially from 'xstream/extra/flattenSequentially';
import {receiveGetSpecificSolicitorGroup, requestGetSpecificSolicitorGroup} from "../actions/groups";

export function getSolicitorSolicitorGroup(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_SOLICITORS_SOLICITOR_GROUP)
		.map(action => ({
			url: BASE_URL + `api/users/GetLawsysAgents`,
			category: 'getSolicitorsSolicitorsGroup',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getSolicitorsSolicitorsGroup')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetSolicitors(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function getUnderwriters(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_UNDERWRITERS)
		.map(action => ({
			url: BASE_URL + `api/users/GetUnderwriters`,
			category: 'getUnderwriters',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));


	let httpResponse$ = sources.HTTP
		.select('getUnderwriters')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetUnderwriters(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function getWorkSources(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_WORK_SOURCES)
		.map(action => ({
			url: BASE_URL + `api/users/GetWorkSources`,
			category: 'getWorkSources',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getWorkSources')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetWorkSources(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function postNewSolicitorGroup(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_POST_SOLICITOR_GROUP)
		.map(action => ({
			url: BASE_URL + `api/Groups/Solicitors`,
			category: 'postSolicitorGroup',
			method: 'POST',
			send: action.payload,
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('postSolicitorGroup')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receivePostSolicitorGroupResponse(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function badRequestSolicitorGroup(sources) {
	let httpResponse$ = sources.HTTP
		.select('postSolicitorGroup')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 400) //todo handle better the responses from the api
		.map(response => actions.badRequestPostSolicitorGroup(JSON.parse(response.response.text).message));

	return {
		ACTION: httpResponse$
	};
}

export function createdResponseNewSolicitor(sources) {
	let httpResponse$ = sources.HTTP
		.select('postSolicitorGroup')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 201)
		.map(response => actions.createdSolicitorGroupResponse(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$
	};
}

export function getSolicitorGroups(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => (action.type === ActionTypes.REQUEST_GET_SOLICITOR_GROUPS))
		.map(action => ({
			url: BASE_URL + 'api/Groups/Solicitors?limit='+(action.payload?action.payload.limit +
			'&offset=' + action.payload.offset +
			(action.payload.search !==null? '&search=' + action.payload.search:'') : "0"),
			category: 'getSolicitorGroups',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));


	let httpResponse$ = sources.HTTP
		.select('getSolicitorGroups')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveSolicitorGroups(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

//cycle that receives failed response from getting the solicitor groups
export function receiveFailedResponseSolicitorGroups(sources) {
    let httpResponse$ = sources.HTTP
        .select('getSolicitorGroups')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToGetSolicitorGroups(response));

    return {
        ACTION: httpResponse$
    };
}

export function getSolicitorGroupsSuggestions(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => (action.type === ActionTypes.REQUEST_GET_SOLICITOR_GROUPS_SUGGESTIONS))
		.map(action => ({
			url: BASE_URL + 'api/Groups/Solicitors?limit='+action.payload.limit +
			'&offset=' + action.payload.offset +
			(action.payload.search !==null? '&search=' + action.payload.search:''),
			category: 'getSolicitorGroupsSuggestions',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));


	let httpResponse$ = sources.HTTP
		.select('getSolicitorGroupsSuggestions')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
        .compose(flattenSequentially)
		.filter(response => response.status === 200)
		.map(response => actions.receiveSolicitorGroupsSuggestions(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}



export function badRespnseGetSolicitorGroupsSuggestions(sources) {
	let httpResponse$ = sources.HTTP
		.select('getSolicitorGroupsSuggestions')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 400)
		.map(response => actions.receiveBadRequestSolicitorGroupsSuggestions(JSON.parse(response.response.text).message));

	return {
		ACTION: httpResponse$
	};
}

//when a new solicitor group is created get the first 20 groups?!
export function getSolicitorGroupsAfterCreation(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => (action.type === ActionTypes.CREATED_SOLICITOR_GROUP_RESPONSE))
		.map(action => ({
			url: BASE_URL + 'api/Groups/Solicitors?limit=200' +
			'&offset=0',
			category: 'getSolicitorGroups',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));


	let httpResponse$ = sources.HTTP
		.select('getSolicitorGroups')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveSolicitorGroups(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function patchSolicitorGroup(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_PATCH_SOLICITOR_GROUP)
		.map(action => ({
			url: BASE_URL + 'api/Groups/Solicitors/' + action.payload.key,
			category: 'patchSolicitorGroup',
			method: 'PATCH',
			send: action.payload.value,
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('patchSolicitorGroup')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.compose(flattenConcurrently)
		.filter(response => response.status === 200)
		.map(response => actions.receivePatchSolicitorGroup(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveFailedResponsePatchSolicitorGroup(sources) {
    let httpResponse$ = sources.HTTP
        .select('patchSolicitorGroup')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .compose(flattenConcurrently)
        .filter(response => response.status !== 200)
        .map(response => actions.failedToPatchSolicitorGroup(response));

    return {
        ACTION: httpResponse$
    };
}

export function patchSelectedSolicitorGroup(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_PATCH_SELECTED_SOLICITOR_GROUP)
		.map(action => ({
			url: BASE_URL + 'api/Groups/Solicitors/' + action.payload.key,
			category: 'patchSelectedSolicitorGroup',
			method: 'PATCH',
			send: action.payload.value,
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('patchSelectedSolicitorGroup')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.compose(flattenConcurrently)
		.filter(response => response.status === 200)
		.map(response => actions.receivePatchSelectedSolicitorGroup(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function badRespnsePatchSelectedSolicitorGroup(sources) {
	let httpResponse$ = sources.HTTP
		.select('patchSelectedSolicitorGroup')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 400)
		.map(response => actions.badRequestPatchSelectedSolicitorGroup(JSON.parse(response.response.text).message))

	return {
		ACTION: httpResponse$
	};
}

//====================CHAIN===================//

export function solicitorGroupEdit(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const httpRequest$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_SPECIFIC_SOLICITOR_GROUP_EDIT)
		.map(action => ({
			url: BASE_URL + 'api/users/GetWorkSources',
			category: 'getWorkSourcesAfterEdit',
			method: 'GET',
			type: 'application/json',
			withCredentials: true,
            payload: action.payload
		}));


	let httpResponse$ = sources.HTTP
		.select('getWorkSourcesAfterEdit')
		.map((response) =>
			response.replaceError((err) => xs.of(err)))
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveWorkSourcesEdit(response.request.payload, response.body));


	return {
		ACTION: httpResponse$,
		HTTP: httpRequest$
	};
}

export function getExpensesAfterWorkSources(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const httpRequest$ = sources.ACTION
        .filter(action => action.type === ActionTypes.RECEIVE_WORK_SOURCES_EDIT)
        .map(action => ({
            url: BASE_URL + 'api/Groups/ExpenseTypes',
            category: 'getExpensesAfterWorkSources',
            method: 'GET',
            type: 'application/json',
            withCredentials: true,
            payload: action.payload.groupId
        }));
    let httpResponse$ = sources.HTTP
        .select('getExpensesAfterWorkSources')
        .map((response) =>
            response.replaceError((err) => xs.of(err)))
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveExpensesEdit(response.request.payload, response.body));
    return {
        ACTION: httpResponse$,
        HTTP: httpRequest$
    }
}

export function getUnderWritersAfterExpenses(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const httpRequest$ = sources.ACTION
		.filter(action => action.type === ActionTypes.RECEIVE_EXPENSES_EDIT)
		.map(action => ({
			url: BASE_URL + 'api/users/GetUnderwriters',
			category: 'getUnderWritersAfterExpenses',
			method: 'GET',
			type: 'application/json',
			withCredentials: true,
            payload: action.payload.groupId
		}));
	let httpResponse$ = sources.HTTP
		.select('getUnderWritersAfterExpenses')
		.map((response) =>
			response.replaceError((err) => xs.of(err)))
		.flatten()
		.filter(response => response.status === 200)
        .map(response => actions.receiveUnderwritersEdit(response.request.payload, response.body));
	return {
		ACTION: httpResponse$,
		HTTP: httpRequest$
	};
}



export function getSolicitorsAfterUnderwriters(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const httpRequest$ = sources.ACTION
		.filter(action => action.type === ActionTypes.RECEIVE_UNDERWRITERS_EDIT)
		.map(action => ({
			url: BASE_URL + 'api/users/GetLawsysAgents',
			category: 'getSolicitorsAfterUnderwriters',
			method: 'GET',
			type: 'application/json',
			withCredentials: true,
            payload: action.payload.groupId

        }));


	let httpResponse$ = sources.HTTP
		.select('getSolicitorsAfterUnderwriters')
		.map((response) =>
			response.replaceError((err) => xs.of(err)))
		.flatten()
		.filter(response => response.status === 200)
        .map(response => actions.receiveSolicitorEdit(response.request.payload, response.body));


	return {
		ACTION: httpResponse$,
		HTTP: httpRequest$
	};
}

export function getCasesAfterSolicitors(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const httpRequest$ = sources.ACTION
		.filter(action => action.type === ActionTypes.RECEIVE_SOLICITOR_EDIT)
		.map(action => ({
			url: BASE_URL + 'api/CaseTypes/CaseTypes',
			category: 'getCasesAfterSolicitors',
			method: 'GET',
			type: 'application/json',
			withCredentials: true,
            payload: action.payload.groupId
		}));


	let httpResponse$ = sources.HTTP
		.select('getCasesAfterSolicitors')
		.map((response) =>
			response.replaceError((err) => xs.of(err)))
		.flatten()
		.filter(response => response.status === 200)
        .map(response => actions.receiveCaseTypesEdit(response.request.payload, response.body));


	return {
		ACTION: httpResponse$,
		HTTP: httpRequest$
	};
}

export function getSolicitorGroupAfterCaseTypes(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const httpRequest$ = sources.ACTION
		.filter(action => action.type === ActionTypes.RECEIVE_CASE_TYPE_EDIT)
		.map(action => ({
			url: BASE_URL + 'api/Groups/Solicitors/' + action.payload.groupId,
			category: 'getSolicitorGroupAfterSolicitors',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getSolicitorGroupAfterSolicitors')
		.map((response) =>
			response.replaceError((err) => xs.of(err)))
		.flatten()
		.filter(response => response.status === 200)
		.map(response => receiveGetSpecificSolicitorGroup(JSON.parse(response.text)))

	return {
		ACTION: httpResponse$,
		HTTP: httpRequest$
	};
}

//===============================================//

// Solicitor Group questions to auto generate solicitor integration spec
export function getGroupQuestionsSpec(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => (action.type === ActionTypes.GET_GROUP_QUESTIONS_SPEC))
		.map(action => ({
			url: BASE_URL + `api/Groups/${action.payload.groupId}/FormsSettings`,
			category: 'getGroupQuestionsSpec',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));


	let httpResponse$ = sources.HTTP
		.select('getGroupQuestionsSpec')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.map(response => response.status === 200 ?
			actions.getGroupQuestionsSpecSuccess(JSON.parse(response.text)) :
			actions.getGroupQuestionsSpecFailure(JSON.parse(response.text))
		);

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function getGroupSpecDto(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => (action.type === ActionTypes.GET_GROUP_SPEC_DTO))
		.map(action => ({
			url: BASE_URL + `api/Applications/spec`,
			category: 'getSpec',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));


	let httpResponse$ = sources.HTTP
		.select('getSpec')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.map(response => response.status === 200 ?
			actions.getGroupSpecDtoSuccess(JSON.parse(response.text)) :
			actions.getGroupSpecDtoFailure(JSON.parse(response.text))
		);

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}
